import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DocumentTypeService } from '../../../core/services/document-type.service';
import { TenantConfigService } from '../../../core/config/tenant-config';
import { StateService } from '../../../core/services/state.service';
import { computed } from '@angular/core';
import { OrderProcessingService } from '../../../core/services/order-processing';

@Component({
    selector: 'app-header',
    imports: [RouterLink],
    templateUrl: './header.html',
    styleUrl: './header.scss',
})
export class Header {
    public documentTypeService = inject(DocumentTypeService);
    public tenantConfigService = inject(TenantConfigService);
    private stateService = inject(StateService);
    public orderProcessing = inject(OrderProcessingService);

    public hasState = computed(() => {
        const code = this.stateService.stateCode();
        return !!code && code !== '' && code !== 'select';
    });

    public stateCode = this.stateService.stateCode;

    constructor(){
    }
    
}
